import { create } from 'zustand';

interface SlotData {
  id: string;
  type: string;
  start: string;
  slotDate: string;
  available_social_referents: any[];
  availableSocialReferents: any[];
}

interface NoDigitalSlotsStore {
  slots: SlotData[];
  loading: boolean;
  assigningSlot: boolean;
  selectedSlotId: string | null;
  fetchNoDigitalSlots: (policyId: string, client: any, startDate?: Date) => Promise<void>;
  clearSlots: () => void;
  setAssigningSlot: (loading: boolean) => void;
  setSelectedSlot: (slotId: string | null) => void; 
}

export const useNoDigitalSlotsStore = create<NoDigitalSlotsStore>((set, get) => ({
  slots: [],
  loading: false,
  assigningSlot: false,
  selectedSlotId: null,
  
  fetchNoDigitalSlots: async (policyId: string, client: any, startDate?: Date) => {
    set({ loading: true });
    
    try {
      const params: any = {
        action: undefined,
        noClear: true
      };
      
      const response = await client.get(`policies/${policyId}/slots`, params);
      
      
      
      if (!response || typeof response !== 'object') {
        console.error('❌ Zustand - Invalid response format:', response);
        set({ slots: [], loading: false });
        return;
      }
      
      const data = response.data || response;
      
      let slotsArray = [];
      
      if (Array.isArray(data)) {
        slotsArray = data;
      } else if (data && typeof data === 'object') {
        slotsArray = data.slots || data.data || data.results || [];
        
        if (!Array.isArray(slotsArray) && data.type) {
          slotsArray = [data];
        }
      }
      
      if (!Array.isArray(slotsArray)) {
        console.error('❌ Zustand - Slots is not an array:', slotsArray);
        set({ slots: [], loading: false });
        return;
      }
      
      const transformedSlots = slotsArray.map((slot: any, index: number) => {
        
        const attributes = slot.attributes || slot;
        
        const availableSocialReferentsRaw = attributes.availableSocialReferents || attributes.available_social_referents || [];
        
        const transformed = {
          id: slot.id || attributes.id || `slot-${index}`,
          type: attributes.type || 'AVAILABLE',
          start: attributes.start || attributes.slotDate,
          slotDate: attributes.slotDate || attributes.start,
          available_social_referents: availableSocialReferentsRaw,
          availableSocialReferents: availableSocialReferentsRaw
        };
        
        return transformed;
      });
      
      set({ slots: transformedSlots, loading: false });
    } catch (error) {
      console.error('❌ Zustand - Error fetching slots:', error);
      set({ slots: [], loading: false });
    }
  },
  
  clearSlots: () => {
    set({ slots: [], selectedSlotId: null, assigningSlot: false });
  },

  setAssigningSlot: (loading: boolean) => {
    set({ assigningSlot: loading });
  },

  setSelectedSlot: (slotId: string | null) => {
    set({ selectedSlotId: slotId });
  }
})); 